import BusinessInNumbers from './BusinessInNumbers';

export default BusinessInNumbers;
